import request from "@/api/axios"
import tokenHelper from "@/helpers/token_helper";


export default {
    //get

    /**
     * @description: 首页电站列表
     * @param {*} params
     * @return {*}
     */
    getIndexStationList(params) {
        return request.get("/app/v1/charging_stations", { params: params })
    },

    /**
     * @description: 电站详情
     * @param {*} id
     * @param {*} obj
     * @return {*}
     */
    getIndexStationDetails(id, obj) {
        return request.get("/app/v1/charging_stations/" + id, { params: obj })
    },
     /**
     * @description: 发票抬头详情
     * @param {*} id
     * @param {*} obj
     * @return {*}
     */
      getTitleDtatils(id) {
        return request.get("/app/v1/user_invoices/" + id,{
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
     /**
     * @description: 提现记录
     * @param {*} id
     * @param {*} obj
     * @return {*}
     */
      getWithRecordList( params) {
        return request.get("/app/v1/users/user_withdraw_records" , {
            params: params,
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
    
    /**
     * @description: 电站详情电桩列表
     * @param {*} params
     * @return {*}
     */
    getChargersList(params) {
        return request.get("/app/v1/charging_stations/" + params + "/chargers")
    },
    /**
     * 查询是否是 VIP 用户
     */
    getVerifyVipUse(params){
        return request.get("/app/v1/charging_stations/chargers/verify_vip_user/"+params , {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
    /**
     * @description: 电桩详情
     * @param {*} params
     * @return {*}
     */
    getChargersDetails(params) {
        return request.get("/app/v1/charging_stations/chargers/" + params)
    },
    /**
   * @description: 支付明细
   * @param {*} params
   * @return {*}
   */
    getUserPayment(params) {
        return request.get("/app/v1/users/user_balance_statements" , {
            params: params,
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
    /**
     * @description: 获取验证码
     * @param {*} params
     * @return {*}
     */
    getSmsCode(params) {
        return request.get("/common/v1/sms", { params: params })
    },
    /**
   * @description: 
   * @param {*} params
   * @return {*}
   */
    getInvoicesDetails(id) {
        return request.get("/app/v1/user_invoices/user_invoice_records/" + id, {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
    /**
     * @description: 订单详情
     * @param {*} params
     * @return {*}
     */
    getOrdersDetails(params) {
        return request.get("/app/v1/orders/" + params, {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
       /**
     * @description: 充电中订单
     * @param {*} params
     * @return {*}
     */
    checkPendingOrder(){
        return  request.get("app/v1/orders/in_progress/list", {
            headers: { Authorization: tokenHelper.readAccessToken() }
        }) 
    },
   /**
    * 检查该用户是否能开启某个电桩充电
    * @param {*} params 
    * @returns 
    */
   getUserPermissions(params){
    return request.get("/app/v1/users/charging_stations/charging_pile/check_start_order_auth?gun_id=" + params, {
        headers: { Authorization: tokenHelper.readAccessToken() }
    })
 
   },
    /**
     * @description: 充电订单列表
     * @param {*} params
     * @return {*}
     */
    getOrderList(params) {
        return request.get("/app/v1/orders/", {
            params: params,
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },


    /**
    * @description: 可开票列表
    * @param {*} params
    * @return {*}
    */
    getReceiptOrders(params) {
        return request.get("/app/v1/user_invoices/orders/list", {
            params: params,
            headers: {
                Authorization: tokenHelper.readAccessToken()
            }
        })
    },

    /**
    * @description: 抬头列表
    * @param {*} params
    * @return {*}
    */
    getTitleList() {
        return request.get("/app/v1/user_invoices", {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },

    /**
     * @description: 首页广告轮播
     * @param {*} params
     * @return {*}
     */
    getHomeSwipe(params) {
        return request.get("/app/v1/banners",{
            params:params
        })
    },


    /**
     * @description: 微信配置信息
     * @param {*} params
     * @return {*}
     */
    getWxConfigInfo(params) {
        return request.get("/app/v1/wechat/jsapi_signature", {
            params: params,
        })
    },

    /**
     * @description: 用户信息
     * @param {*} params
     * @return {*}
     */
    getUserInfo() {
        return request.get("/app/v1/users/info", {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
    /**
     * @description: 运营商发票
     * @return {*}
     */
    getInvoiceOfProvider() {
        return request.get("/app/v1/user_invoices/service_provider/invoice_records", {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },

    /**
        * @description: 发票记录
        * @return {*}
        */
    getInvoiceRecord(id,params) {
        if(id == undefined){
            id = ''
        }
        return request.get("/app/v1/user_invoices/records/list/"+id, {
            params: params,
            headers: {
                Authorization: tokenHelper.readAccessToken()
            }
        })
    },

    //delete

    /**
       * @description: 删除抬头
       * @param {*} params
       * @return {*}
       */
    deleteInvoices(params) {
        return request.delete("/app/v1/user_invoices/" + params, {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },



    
    //post
    /**
     * @description: 获取token
     * @param {*} params
     * @return {*}
     */
    getToken(params) {
        return request.post("/app/v1/wechat/sign_in", params)
    },
    /**
     * @description: secretKey授权
     * @param {*} params
     * @return {*}
     */
    authSecret(params) {
        return request.post("/app/v1/auth/secret", params)
    },
    /**
        * @description: 绑定手机号
        * @param {*} params
        * @return {*}
        */
    bindPhone(params) {
        return request.post("/app/v1/wechat/auth/phone_number", params)
    },
    /**
      * @description: 开具发票
      * @param {*} params
      * @return {*}
      */
    postUserInvoices(params) {
        return request.post("/app/v1/user_invoices/user_invoice_record", params, {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
       /**
      * @description: 退款
      * @param {*} params
      * @return {*}
      */
        apiPostWithdrawal(params) {
            return request.post("/app/v1/users/withdraw_record", params, {
                headers: { Authorization: tokenHelper.readAccessToken() }
            })
        },
    /**
     * @description: 创建抬头
     * @param {*} params
     * @return {*}
     */
    createUserTitle(params) {
        return request.post("/app/v1/user_invoices", params, {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
    
    /**
     * 微信支付
     * @param {*} params 
     * @returns 
     */
    postWebWxPay(params) {
        return request.post("/app/v1/wechat_pay_partner/top_up", params, { headers: { Authorization: tokenHelper.readAccessToken() }, })
    },
    directWxPay(params){
    return request.post("/app/v1/wepay/wechat_jsapi/top_up", params, { headers: { Authorization: tokenHelper.readAccessToken() }, })
    },
    /**
    * 微信支付主动查询接口
    * @param {*} params 
    * @returns 
    */
    postWebCheckPayOrders(params) {
        return request.post("/app/v1/wepay/web_check_order", params, { headers: { Authorization: tokenHelper.readAccessToken() }, })
    },
    //put
    /**
     * @description: 开锁
     * @param {*} params
     * @return {*}
     */
   putOpenLock(id) {
        return request.put("/app/v1/users/"+id+"/lock_code", {"lock_code": "ha"}, {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
    /**
     * @description: 开启充电
     * @param {*} params
     * @return {*}
     */
    putStartCharge(params) {
        return request.put("/app/v1/orders/start_charging/" + params, "", {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
       /**
     * @description: 修改抬头
     * @param {*} params
     * @return {*}
     */
        updateTitle(id,params) {
            return request.put("/app/v1/user_invoices/" + id, params, {
                headers: { Authorization: tokenHelper.readAccessToken() }
            })
        },
        
    /**
     * @description: 停止充电
     * @param {*} params
     * @return {*}
     */
    putStopCharge(params) {
        return request.put("/app/v1/orders/stop_charging/" + params, "", {
            headers: { Authorization: tokenHelper.readAccessToken() }
        })
    },
     /**
     * @description: 支付订单
     * @param {*} params
     * @return {*}
     */
    putPayOders(params){
        return request.put("/app/v1/orders/paid/" + params, "", {
            headers: { Authorization: tokenHelper.readAccessToken() }
        }) 
    }
}